import React, { useCallback, useMemo, useState } from 'react'
import { trackingAllowed } from '~/utils'

export const FacebookPixelContext = React.createContext({})

function FacebookPixelProvider({ children, pixelId }) {
  const [isInitialized, setIsInitialized] = useState(false)

  const initialize = useCallback(() => {
    return new Promise(resolve => {
      // If not allowed or not production
      if (!trackingAllowed || !pixelId) return resolve()
      // If already initialized
      if (isInitialized || typeof window.fbq !== 'undefined') return resolve()

      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.defer = true
      script.crossorigin = 'anonymous'
      script.innerText = `!function(f,b,e,v,n,t,s)
                  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                  n.queue=[];t=b.createElement(e);t.async=!0;
                  t.src=v;s=b.getElementsByTagName(e)[0];
                  s.parentNode.insertBefore(t,s)}(window, document,'script',
                  'https://connect.facebook.net/en_US/fbevents.js');`
      document.body.appendChild(script)

      const noscript = document.createElement('noscript')
      noscript.innerText = `<img height="1" width="1" style="display:none"
                  src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`
      document.body.appendChild(noscript)

      window.fbq('init', pixelId)

      setIsInitialized(true)
      resolve()
    })
  }, [])

  const track = useCallback(async trackingEvent => {
    if (!trackingEvent) {
      throw new Error('track() requires a tracking event!')
    }

    await initialize()

    if (window.fbq) {
      window.fbq('track', trackingEvent)
    }
  }, [])

  const value = useMemo(() => {
    return {
      initialize,
      track,
    }
  }, [initialize, track])

  return <FacebookPixelContext.Provider value={value}>{children}</FacebookPixelContext.Provider>
}

export default FacebookPixelProvider
